"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _filter = _interopRequireDefault(require("../services/filter.service"));
var _sort = _interopRequireDefault(require("../services/sort.service"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _search = require("../utils/search.utils");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _filter2 = _interopRequireDefault(require("../utils/filter.utils"));
var _sort2 = _interopRequireWildcard(require("../utils/sort.utils"));
var _searchResults = require("../utils/search-results.utils");
var _constants = require("../constants");
var _itineraryWithBaggage = _interopRequireDefault(require("../factories/itinerary-with-baggage.factory"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var DomesticSearchResultsStore = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, _dec12 = _mobx.action.bound, _dec13 = _mobx.action.bound, _dec14 = _mobx.action.bound, _dec15 = _mobx.action.bound, _dec16 = _mobx.action.bound, _dec17 = _mobx.action.bound, _dec18 = _mobx.action.bound, _dec19 = _mobx.action.bound, _dec20 = _mobx.action.bound, (_class = function () {
  function DomesticSearchResultsStore(initialState, $env) {
    var _this = this;
    if (initialState === void 0) {
      initialState = {};
    }
    (0, _classCallCheck2.default)(this, DomesticSearchResultsStore);
    (0, _initializerDefineProperty2.default)(this, "filtersState", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "filterKeys", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "appliedFilters", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "sortKey", _descriptor4, this);
    (0, _initializerDefineProperty2.default)(this, "selectedFlightId", _descriptor5, this);
    (0, _initializerDefineProperty2.default)(this, "outboundFlightId", _descriptor6, this);
    (0, _initializerDefineProperty2.default)(this, "selectedExtraBaggageOption", _descriptor7, this);
    this.$env = $env;
    this.searchResults = {};
    this.topAirlines = {};
    this.direction = _constants.OUTBOUND;
    this.updateInitialState(initialState);
    (0, _mobx.autorun)(function () {
      return _this.filtersParams && _this.updateAppliedFilters();
    });
  }
  (0, _createClass2.default)(DomesticSearchResultsStore, [{
    key: "allSearchResults",
    get: function get() {
      return (0, _searchResults.getDomesticAvailableResults)({
        results: this.direction === _constants.OUTBOUND ? this.searchResults.outboundItineraries : this.searchResults.inboundItineraries,
        direction: this.direction,
        outboundFlight: this.outboundFlight
      });
    }
  }, {
    key: "flightsFiltersParams",
    get: function get() {
      return (0, _map2.default)(this.allSearchResults, 'filterParams');
    }
  }, {
    key: "filtersData",
    get: function get() {
      return _filter2.default.extractData(this.flightsFiltersParams, this.filterKeys);
    }
  }, {
    key: "filtersParams",
    get: function get() {
      return _filter2.default.extractAllParams(this.filtersState);
    }
  }, {
    key: "filtersQuery",
    get: function get() {
      return _filter2.default.extractAllQuery(this.filtersParams);
    }
  }, {
    key: "filteredSearchResults",
    get: function get() {
      return _filter2.default.execute(this.allSearchResults, this.filtersParams);
    }
  }, {
    key: "sortedSearchResults",
    get: function get() {
      return (0, _sort2.default)(this.filteredSearchResults, this.sortKey);
    }
  }, {
    key: "isFiltered",
    get: function get() {
      return !!this.filtersQuery;
    }
  }, {
    key: "hasNoResults",
    get: function get() {
      return this.searchResults.hasError || this.searchResults.isCompleted && !this.allSearchResults.length;
    }
  }, {
    key: "hasFilters",
    get: function get() {
      return !(0, _isEmpty2.default)(this.filtersData);
    }
  }, {
    key: "shouldResetFilters",
    get: function get() {
      return this.searchResults.isCompleted && !this.hasNoResults && !this.filteredSearchResults.length;
    }
  }, {
    key: "selectedFlight",
    get: function get() {
      var itinerary = this.searchResults.getItinerary(this.selectedFlightId);
      var option = this.selectedExtraBaggageOption;
      return (0, _itineraryWithBaggage.default)(itinerary, option);
    }
  }, {
    key: "outboundFlight",
    get: function get() {
      var itinerary = this.searchResults.getItinerary(this.outboundFlightId);
      var option = this.outboundExtraBaggageOption;
      return (0, _itineraryWithBaggage.default)(itinerary, option);
    }
  }, {
    key: "selectedFlightGroupId",
    get: function get() {
      return (0, _get2.default)(this.selectedFlight, 'group');
    }
  }, {
    key: "$filter",
    get: function get() {
      return (0, _filter.default)({
        filtersState: this.filtersState,
        filtersParams: this.filtersParams
      });
    }
  }, {
    key: "displayPriceFilterState",
    get: function get() {
      return _filter2.default.getDisplayPriceFilterState(this.filtersState.price, this.$env.currency);
    }
  }, {
    key: "mergedAirlineFilterState",
    get: function get() {
      return _filter2.default.merge(this.filtersState.airline);
    }
  }, {
    key: "searchRoute",
    get: function get() {
      return (0, _search.getRouteFromQuery)(this.searchResults.searchQuery);
    }
  }, {
    key: "availableAirlines",
    get: function get() {
      return (0, _map2.default)(this.filtersState.airline, 'code');
    }
  }, {
    key: "searchTopAirlines",
    get: function get() {
      return this.topAirlines.getValidTopAirlines({
        route: this.searchRoute,
        airlines: this.availableAirlines
      });
    }
  }, {
    key: "availableAppliedFilters",
    get: function get() {
      return _filter2.default.getAvailableAppliedFilters(this.appliedFilters, this.searchTopAirlines);
    }
  }, {
    key: "totalFlightsCount",
    get: function get() {
      return (0, _get2.default)(this.allSearchResults, 'length');
    }
  }, {
    key: "filteredFlightsCount",
    get: function get() {
      return (0, _get2.default)(this.filteredSearchResults, 'length');
    }
  }, {
    key: "hasQuickFilters",
    get: function get() {
      return !(0, _isEmpty2.default)(this.searchTopAirlines) || !!(0, _find2.default)(this.filtersState.maxStop, {
        code: 0,
        isAvailable: true
      });
    }
  }, {
    key: "hasAppliedFilters",
    get: function get() {
      return !(0, _isEmpty2.default)(this.appliedFilters);
    }
  }, {
    key: "sortPriceHashMap",
    get: function get() {
      return (0, _sort2.getSortPriceHashMap)(this.filteredSearchResults);
    }
  }, {
    key: "sortPriceDurationHashMap",
    get: function get() {
      return (0, _sort2.getSortPriceDurationHashMap)(this.filteredSearchResults);
    }
  }, {
    key: "sortItinerariesHashMap",
    get: function get() {
      return (0, _sort2.getSortItinerariesHashMap)(this.filteredSearchResults);
    }
  }, {
    key: "topPicks",
    get: function get() {
      return (0, _sort2.getTopPicks)(this.sortItinerariesHashMap);
    }
  }, {
    key: "resultsWithoutTopPicks",
    get: function get() {
      return (0, _sort2.getResultsWithoutTopPicks)({
        topPicks: this.topPicks,
        searchResults: this.sortedSearchResults,
        isDomestic: true
      });
    }
  }, {
    key: "$sort",
    get: function get() {
      return (0, _sort.default)({
        sortItinerariesHashMap: this.sortItinerariesHashMap
      });
    }
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "initializeAllFiltersState",
    value: function initializeAllFiltersState(initialFiltersQuery) {
      this.filtersState = _filter2.default.initializeAll(this.filtersData, this.filterKeys);
      if (initialFiltersQuery) {
        this.updateAllFiltersState(initialFiltersQuery);
      }
    }
  }, {
    key: "initializeFilterState",
    value: function initializeFilterState(filterKey) {
      if ((0, _includes2.default)(this.filterKeys, filterKey)) {
        this.filtersState[filterKey] = _filter2.default.initialize(filterKey, this.filtersData[filterKey]);
      }
    }
  }, {
    key: "resetAllFiltersState",
    value: function resetAllFiltersState() {
      this.initializeAllFiltersState();
    }
  }, {
    key: "resetFilterState",
    value: function resetFilterState(filterKey) {
      this.initializeFilterState(filterKey);
    }
  }, {
    key: "updateAllFiltersState",
    value: function updateAllFiltersState(filtersQuery) {
      this.filtersState = _filter2.default.updateAll(this.filtersState, filtersQuery);
    }
  }, {
    key: "updateFilterState",
    value: function updateFilterState(filterKey, filterQuery) {
      if ((0, _includes2.default)(this.filterKeys, filterKey)) {
        var filterState = this.filtersState[filterKey];
        this.filtersState[filterKey] = _filter2.default.update({
          filterKey: filterKey,
          filterState: filterState,
          filterQuery: filterQuery
        });
      }
    }
  }, {
    key: "toggleFilterItemState",
    value: function toggleFilterItemState(filterKey, filterPayload) {
      var filterState = this.filtersState[filterKey];
      this.filtersState[filterKey] = _filter2.default.toggle({
        filterKey: filterKey,
        filterState: filterState,
        filterPayload: filterPayload
      });
    }
  }, {
    key: "toggleAllFilterItemState",
    value: function toggleAllFilterItemState(filterKey, filterCode) {
      var filterState = this.filtersState[filterKey];
      this.filtersState[filterKey] = _filter2.default.toggleAll({
        filterKey: filterKey,
        filterState: filterState,
        filterCode: filterCode
      });
    }
  }, {
    key: "setFilterItemState",
    value: function setFilterItemState(filterKey, filterPayload) {
      var filterState = this.filtersState[filterKey];
      this.filtersState[filterKey] = _filter2.default.set({
        filterKey: filterKey,
        filterState: filterState,
        filterPayload: filterPayload
      });
    }
  }, {
    key: "setAllFilterItemState",
    value: function setAllFilterItemState(filterKey, filterPayload) {
      var filterState = this.filtersState[filterKey];
      this.filtersState[filterKey] = _filter2.default.setAll({
        filterKey: filterKey,
        filterState: filterState,
        filterPayload: filterPayload
      });
    }
  }, {
    key: "updateFilterStateRange",
    value: function updateFilterStateRange(filterKey, filterRange) {
      var filterState = this.filtersState[filterKey];
      this.filtersState[filterKey] = _filter2.default.updateRange(filterState, filterRange);
    }
  }, {
    key: "resetSubFilterState",
    value: function resetSubFilterState(filterKey, filterPayload) {
      if ((0, _includes2.default)(this.filterKeys, filterKey)) {
        this.filtersState[filterKey] = _filter2.default.initializeSub({
          filterKey: filterKey,
          filterData: this.filtersData[filterKey],
          filterState: this.filtersState[filterKey],
          filterPayload: filterPayload
        });
      }
    }
  }, {
    key: "filterOutNearbyAirports",
    value: function filterOutNearbyAirports() {
      this.updateFilterState('airport', this.searchResults.searchRequest.requestAirportsFilterQuery);
    }
  }, {
    key: "updateAppliedFilters",
    value: function updateAppliedFilters() {
      this.appliedFilters = _filter2.default.getAppliedFilters(this.filtersState, this.appliedFilters);
    }
  }, {
    key: "removeAppliedFilter",
    value: function removeAppliedFilter(appliedFilter) {
      if (!(0, _isPlainObject2.default)(appliedFilter) && !(0, _isPlainObject2.default)(appliedFilter.info)) return;
      if (appliedFilter.removalMode === 'reset') {
        this.resetFilterState(appliedFilter.info.key);
      } else {
        this.toggleFilterItemState(appliedFilter.info.key, appliedFilter.info);
      }
    }
  }, {
    key: "initializeSortKey",
    value: function initializeSortKey() {
      this.sortKey = _constants.DEFAULT_SORT_KEY;
    }
  }, {
    key: "setSortKey",
    value: function setSortKey(sortKey) {
      if ((0, _sort2.isValidSortKey)(sortKey)) {
        this.sortKey = sortKey;
      }
    }
  }, {
    key: "setFilterKeys",
    value: function setFilterKeys(filterKeys) {
      if ((0, _isArray2.default)(filterKeys)) {
        this.filterKeys = filterKeys;
      }
    }
  }, {
    key: "setSelectedFlightId",
    value: function setSelectedFlightId(itineraryId) {
      this.selectedFlightId = itineraryId;
    }
  }, {
    key: "setSelectedExtraBaggage",
    value: function setSelectedExtraBaggage(option) {
      this.selectedExtraBaggageOption = option;
    }
  }]);
  return DomesticSearchResultsStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filtersState", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filterKeys", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.DEFAULT_DOMESTIC_FILTER_KEYS;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "appliedFilters", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortKey", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.DEFAULT_SORT_KEY;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedFlightId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "outboundFlightId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedExtraBaggageOption", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "allSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "flightsFiltersParams", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "flightsFiltersParams"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filtersData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filtersData"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filtersParams", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filtersParams"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filtersQuery", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filtersQuery"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filteredSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortedSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortedSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFiltered", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFiltered"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasNoResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasNoResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "shouldResetFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldResetFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedFlight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedFlight"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "outboundFlight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "outboundFlight"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedFlightGroupId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedFlightGroupId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "$filter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "$filter"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayPriceFilterState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayPriceFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "mergedAirlineFilterState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mergedAirlineFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchRoute", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchRoute"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "availableAirlines", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableAirlines"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchTopAirlines", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchTopAirlines"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "availableAppliedFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableAppliedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "totalFlightsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalFlightsCount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filteredFlightsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredFlightsCount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasQuickFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasQuickFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasAppliedFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasAppliedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortPriceHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortPriceHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortPriceDurationHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortPriceDurationHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortItinerariesHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortItinerariesHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topPicks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topPicks"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resultsWithoutTopPicks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "resultsWithoutTopPicks"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "$sort", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "$sort"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeAllFiltersState", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "initializeAllFiltersState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeFilterState", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetAllFiltersState", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "resetAllFiltersState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetFilterState", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "resetFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateAllFiltersState", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "updateAllFiltersState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateFilterState", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "updateFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "toggleFilterItemState", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "toggleFilterItemState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "toggleAllFilterItemState", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAllFilterItemState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setFilterItemState", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "setFilterItemState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setAllFilterItemState", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "setAllFilterItemState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateFilterStateRange", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "updateFilterStateRange"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetSubFilterState", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "resetSubFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filterOutNearbyAirports", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "filterOutNearbyAirports"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateAppliedFilters", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "updateAppliedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "removeAppliedFilter", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "removeAppliedFilter"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeSortKey", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "initializeSortKey"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSortKey", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "setSortKey"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setFilterKeys", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "setFilterKeys"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSelectedFlightId", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedFlightId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSelectedExtraBaggage", [_dec20], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedExtraBaggage"), _class.prototype)), _class));